// Ícones do skin Atlas Vivo (fase 8 — docs/plans/overhaul-ux-atlas-vivo.md).
// SVGs inline no estilo lucide (stroke, 24x24, sem dependência nova) — o app
// hoje usa só emoji; o render de referência usa lucide via CDN, que não
// serve pra build offline/self-contained do projeto.
const PATHS = {
  map: 'M9 3 3 5v16l6-2 6 2 6-2V3l-6 2-6-2Zm0 0v16m6-16v16',
  'calendar-days': 'M8 2v4M16 2v4M3 8h18M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm2 8h.01M12 13h.01M17 13h.01M7 17h.01M12 17h.01',
  sparkles: 'm12 3 1.4 4.2L18 9l-4.6 1.8L12 15l-1.4-4.2L6 9l4.6-1.8L12 3ZM5 17l.7 2.1L8 20l-2.3.9L5 23l-.7-2.1L2 20l2.3-.9L5 17ZM19 15l.6 1.8L21.5 17.5l-1.9.7L19 20l-.6-1.8-1.9-.7 1.9-.7L19 15Z',
  database: 'M12 5c4.4 0 8-1.34 8-3s-3.6-3-8-3-8 1.34-8 3 3.6 3 8 3Zm8-3v14c0 1.66-3.6 3-8 3s-8-1.34-8-3V2m16 5c0 1.66-3.6 3-8 3s-8-1.34-8-3m16 7c0 1.66-3.6 3-8 3s-8-1.34-8-3',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10 2-4.35-4.35',
  'chevron-left': 'm15 18-6-6 6-6',
  'chevron-right': 'm9 18 6-6-6-6',
  'sliders-horizontal': 'M4 6h6M14 6h6M4 12h10M18 12h2M4 18h2M10 18h10M8 3v6M16 9v6M6 15v6',
  'map-pin': 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  route: 'M6 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM18 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM9 19h4a4 4 0 0 0 4-4V9',
  headphones: 'M3 14v-2a9 9 0 0 1 18 0v2M3 14a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H3Zm18 0h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Z',
  'notebook-pen': 'M13.4 2.6a2 2 0 0 1 2.83 2.83L7 14.66 3 16l1.34-4L13.4 2.6ZM4 22h13a2 2 0 0 0 2-2V9M4 8V6a2 2 0 0 1 2-2h3',
  'maximize-2': 'M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7',
  x: 'M18 6 6 18M6 6l12 12',
  'arrow-right': 'M5 12h14M13 6l6 6-6 6',
  'settings-2': 'M20 7h-9M14 17H5M17 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM7 14a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
  play: 'M6 4.5v15l12-7.5-12-7.5Z',
  book: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M4 19.5A2.5 2.5 0 0 0 6.5 22H20V2H6.5A2.5 2.5 0 0 0 4 4.5v15Z',
  download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3',
  github: 'M15 22v-4a4.8 4.8 0 0 0-1-3.2c3.2-.4 6.5-1.6 6.5-7a5.4 5.4 0 0 0-1.5-3.8 5 5 0 0 0-.1-3.8s-1.2-.4-4 1.4a13.4 13.4 0 0 0-7 0C4.8 2.4 3.6 2.8 3.6 2.8a5 5 0 0 0-.1 3.8A5.4 5.4 0 0 0 2 10.9c0 5.4 3.3 6.6 6.5 7a4.8 4.8 0 0 0-1 3.2v4M9 18c-4.5 1.5-4.5-2.2-6.5-2.5',
  'bar-chart': 'M3 3v18h18M7 16v-5M12 16V8M17 16v-9',
  'calendar-heart': 'M8 2v4M16 2v4M3 8h18M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm7 8h.01',
  footprints: 'M7 16a3 2.5 0 1 0 0-5 3 2.5 0 0 0 0 5ZM17 12a3 2.5 0 1 0 0-5 3 2.5 0 0 0 0 5Z',
};

function AtlasIcon({ name, size = 18, className, ...rest }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={d} />
    </svg>
  );
}

export default AtlasIcon;
